import * as React from "react";
import EventListener, { withOptions } from "react-event-listener";
import { List as MaterialList } from "material-ui";
import IconButton from "material-ui/IconButton";
import ClearIcon from "material-ui/svg-icons/content/clear";
import { BaseComponent } from "components/BaseComponent/BaseComponent";
import { throttle } from "lodash";
import styles = require("./style.less");
import BorderedListItem from "components/BorderedListItem";
import WindowHelper from "utils/WindowHelper/WindowHelper";

interface RemoveItemsListProps<R> {
    empty?: React.ReactNode;
    data: R[];
    clearButtonToolTip?: string;
    listActions?: JSX.Element[];
    onRow(item: R, idx: number): React.ReactNode;
    onRowTouch?(item: R): void;
    onRemoveRow?(item: R): void;
}

export abstract class RemoveItemsList<R> extends BaseComponent<RemoveItemsListProps<R>, any> {
    private topActionsMenu: any;
    private bottomActionsMenu: any;
    private handleResize: any;
    private handleScroll: any;
    private pollInterval: any;

    constructor(props: RemoveItemsListProps<R>) {
        super(props);

        this.updateButtonsVisibility = this.updateButtonsVisibility.bind(this);
        this.handleResize = throttle(this.updateButtonsVisibility, 100);
        this.handleScroll = throttle(this.updateButtonsVisibility, 50);
    }

    componentDidMount() {
        this.updateButtonsVisibility();

        this.pollInterval = setInterval(() => {
            this.updateButtonsVisibility();
        }, 1000);
    }

    componentWillUnmount() {
        this.handleResize.cancel();
        this.handleScroll.cancel();
        clearInterval(this.pollInterval);
    }

    render() {
        const actions = (this.props.listActions || []).map((action, index) => React.cloneElement(action, { key: index }));
        return (
            <div>
                <EventListener
                    target="window"
                    onResize={this.handleResize}
                    onScroll={withOptions(this.handleScroll, { passive: true, capture: false })}
                />
                <div ref={el => this.topActionsMenu = el} className={styles.actionsMenu}>{actions}</div>
                {this.props.data.length === 0 && this.props.empty && <div className={styles.emptyList}>{this.props.empty}</div>}
                {this.props.data.length !== 0 && <MaterialList>
                    {this.props.data.map((item, index) => this.buildItem(item, index))}
                </MaterialList>}
                <div ref={el => this.bottomActionsMenu = el} style={{ visibility: "hidden" }} className={styles.actionsMenu}>{actions}</div>
            </div>
        );
    }

    private updateButtonsVisibility() {
        if (this.topActionsMenu && this.bottomActionsMenu) {
            let result = "visible";
            if (WindowHelper.isElementInViewport(this.topActionsMenu) && WindowHelper.isElementCenterTouchable(this.topActionsMenu)) {
                result = "hidden";
            } else if (!WindowHelper.isElementInViewport(this.bottomActionsMenu)) {
                // If neither are visible, it might be that we're in a tab that isn't showing
                // so hide the bottom one so we don't show both when we come back.
                result = "hidden";
            }
            this.bottomActionsMenu.style.visibility = result;
        }
    }

    private buildItem(item: R, index: number) {
        const clearButton = this.props.onRemoveRow ? <IconButton
            tooltip={this.props.clearButtonToolTip}
            onClick={e => {
                e.stopPropagation();
                this.props.onRemoveRow(item);
            }}>
            <ClearIcon />
        </IconButton> : null;

        return <BorderedListItem key={(item as any).Id || index} rightIconButton={clearButton}
            onClick={this.props.onRowTouch ? (e: any) => this.onTouch(item) : null}
            disabled={this.props.onRowTouch ? false : true}>
            {this.props.onRow(item, index)}
        </BorderedListItem>;
    }

    private onTouch(item: R) {
        if (this.props.onRowTouch) {
            this.props.onRowTouch(item);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/RemoveItemsList/RemoveItemsList.tsx